import { render, staticRenderFns } from "./ServiziAgendaField.vue?vue&type=template&id=595a5d7a&scoped=true&"
import script from "./ServiziAgendaField.vue?vue&type=script&lang=js&"
export * from "./ServiziAgendaField.vue?vue&type=script&lang=js&"
import style0 from "./ServiziAgendaField.vue?vue&type=style&index=0&id=595a5d7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595a5d7a",
  null
  
)

export default component.exports